import EfSectionLR from '@elem/ui/ef-section-l-r';
import { useProductStore } from '../../ProductProvider';
import { PAGE_TYPE } from '../../constants';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionLRC');
    const { pageType } = useProductStore();
    const BG_MAP: any = {
        [PAGE_TYPE.BASE]: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1726039845876/pc_SectionLRC_base.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1726039838014/m_SectionLRC_base.jpg',
        },
        [PAGE_TYPE.MOTOR]: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1725605169806/pc_Temperature%20Safe.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1725605259311/m_Temperature%20Safe.jpg',
        },
    };
    const bg = BG_MAP[pageType];

    return (
        <div className={styles.TheComp}>
            <EfSectionLR pc={bg.pc} h5={bg.h5} label={t('label')} title={t('title')} desc={t('desc')} />
        </div>
    );
}
